import { z } from 'zod'

export const VerifyTwoFactorSetupDTO = z.object({
  setup_challenge_id: z.string().uuid(),
  code: z.string().length(6)
})

export type VerifyTwoFactorSetupDTO = z.infer<typeof VerifyTwoFactorSetupDTO>

export function mapVerifyTwoFactorSetupToDTO (
  setupChallengeId: string,
  code: string
): VerifyTwoFactorSetupDTO {
  return {
    setup_challenge_id: setupChallengeId,
    code
  }
}
